import * as React from 'react';

import { LockStatusHelper, LockUnlockPermissionsState } from '../../../ts/helpers/LockStatusHelper';

export class PermissionLockStatus extends React.Component<PermissionLockStatus.Props, PermissionLockStatus.State> {

  static displayName = 'PermissionLockStatus';

  static element = React.createFactory(PermissionLockStatus);

  public render() {
    if (this.props.lockState != null && this.props.sectionHeaderMessage != null && this.props.sectionHeaderMessage !== '') {
      const iconClass = 'tb-lock-icon ' + LockStatusHelper.getGrayLockIconClass(this.props.lockState);
      return React.createElement('div', { className: 'tb-section-header-lock-status' },
          React.createElement('span', { className: iconClass }),
          React.createElement('span', { className: 'tb-section-header-lock-text' },
            this.props.sectionHeaderMessage));
    } else {
      return null;
    }
  }

}

export module PermissionLockStatus {

  export interface Props {
    lockState: LockUnlockPermissionsState | null;
    sectionHeaderMessage: string | null;
  }

  export interface State {
  }

}
